var API_IMG_TITLE='"蓉智云管理云平台"';
var domainName="https://api.chengdu.xinyikeji.com.cn/";
var download="https://sys.chengdu.xinyikeji.com.cn/";
var assetsPublicPath='/';
module.exports = {
    API_IMG_TITLE:API_IMG_TITLE, //项目名称
    domainName:domainName, //域名
    download:download,
    interfacePrefix:'index.php/', //接口前缀
    port:8086, //本地端口
    assetsPublicPath:assetsPublicPath, //打包后服务器文件路径
}


//////////////////
// WEBPACK FOOTER
// ./vue.config.js
// module id = D/cJ
// module chunks = 38